export const iamTheme = {
   light: {
      userProfile: {
         containerBgColor: 'bg-gray-50',
         titleColor: 'text-gray-700',
         descriptionColor: 'text-gray-500'
      },
      userDetails: {
         avatarSectionBgColor: 'bg-gray-100',
         avatarSectionBorderColor: 'border-gray-200',
         detailsSectionBgColor: 'bg-white',
         detailsSectionBorderColor: 'border-gray-300',
         dividerColor: 'bg-gray-200',
         labelColor: 'text-gray-500',
         valueColor: 'text-gray-600'
      },
      userLogOut: {
         containerBgColor: 'bg-white',
         containerBorderColor: 'border-gray-300',
         titleColor: 'text-gray-800',
         descriptionColor: 'text-gray-500'
      },
      userPIN: {
         containerBgColor: 'bg-white',
         containerBorderColor: 'border-gray-300',
         titleColor: 'text-gray-800',
         fieldLabelColor: 'text-gray-600',
         fieldValueColor: 'text-gray-700',
         dividerColor: 'bg-gray-300',
         headerTitleColor: 'text-gray-900',
      }
   },
   dark: {}
}
